<template>
  <div class="col-4 sidebar-container">
    <SearchField class="mt-4" :placeholder="$t('sidebar.search_users')" @textChanged="searchTextChanged"/>
    <Loading v-if="searchUsersLoading" />
    <Error v-if="searchUsersLoadError" />
    <SidebarMenu v-if="searchedText.length > 0" :items="searchedUsers" :selectedItem="selectedItem" @itemSelected="itemSelected"/>
    <SidebarButtons :buttons="sidebarButtons" @buttonActive="buttonActive"/>
    <Loading v-if="usersLoading" />
    <Error v-if="usersLoadError" />
    <SidebarMenu v-for="(button, index) in activatedButtons" :key="index" :groupColor="button.fillColor" :items="users | buttonLabel(button.label)" :selectedItem="selectedItem" @itemSelected="itemSelected" @loadMore="loadMore" :label="button.label" :showMore="(!showMore.hasOwnProperty(button.label) && firstReqLength == 25) || showMore[button.label] === 25"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import config from 'config'
import SidebarButtons from '@/components/SidebarButtons.vue'
import SearchField from '@/components/SearchField.vue'
import SidebarMenu from '@/components/SidebarMenu.vue'
import Loading from '@/components/Loading.vue'
import Error from '@/components/Error.vue'
export default {
  components: {
    SidebarButtons,
    SearchField,
    SidebarMenu,
    Loading,
    Error
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('test', ['sharingUsers', 'testProfile', 'testData', 'stats']),
    buttonActive: function (id, active) {
      if (id === 3) {
        // all clicked
        var i = 0
        this.sidebarButtons.forEach(btn => {
          if (active) {
            this.activeButtons |= (1 << i)
          } else {
            this.activeButtons &= ~(1 << i)
          }

          this.sidebarButtons = this.sidebarButtons.map((button, index) => {
            if (index === i) {
              button.active = active
            }
            return button
          })
          i++
        })
      } else {
        if (active) {
          this.activeButtons |= (1 << id)
        } else {
          this.activeButtons &= ~(1 << id)
        }

        this.sidebarButtons = this.sidebarButtons.map((button, index) => {
          if (index === id) {
            button.active = active
          }
          return button
        })
      }
    },
    itemSelected: function (item) {
      if (this.disabled) {
        notify({
          text: this.$t('more.please_wait'),
          theme: 'blue'
        })
        return
      }
      this.selectedItem = item
      this.testProfile(item.uuid)
      document.title = config.defaultTitle
    },
    searchTextChanged: function (text) {
      this.searchedText = text
      this.sharingUsers({queryName: text, label: undefined})
    },
    loadMore: function (label) {
      var page = 0
      if (this.showMorePages.hasOwnProperty(label)) {
        page = this.showMorePages[label]
      }

      this.sharingUsers({queryName: undefined, label: label, page})
      // will set returned items count on success response
      Vue.set(this.showMore, label, true)
      this.showMorePages[label] = page + 1
    }
  },
  computed: {
    ...mapState({
      users: state => state.test.sharingUsers.items,
      searchedUsers: state => state.test.searchedUsers.items,
      statistics: state => state.test.stats.item,
      usersLoading: state => state.test.sharingUsers.loading,
      usersLoadError: state => state.test.sharingUsers.error,
      searchUsersLoading: state => state.test.searchedUsers.loading,
      searchUsersLoadError: state => state.test.searchedUsers.error
    }),
    activatedButtons: function () {
      return this.sidebarButtons.filter(btn => {
        return btn.active && btn.label !== 'all'
      })
    },
    sidebarButtons: function () {
      var res = [
        {
          caption: this.statistics && this.statistics.red ? this.statistics.red.toString() : '0',
          borderColor: this.themes[`redFlagColor`],
          fillColor: this.themes[`redFlagColor`],
          color: this.themes[`redFlagColor`],
          active: (this.activeButtons & (1 << 0)) > 0,
          label: 'red'
        },
        {
          caption: this.statistics && this.statistics.yellow ? this.statistics.yellow.toString() : '0',
          borderColor: this.themes[`yellowFlagColor`],
          fillColor: this.themes[`yellowFlagColor`],
          color: this.themes[`yellowFlagColor`],
          active: (this.activeButtons & (1 << 1)) > 0,
          label: 'yellow'
        },
        {
          caption: this.statistics && this.statistics.green ? this.statistics.green.toString() : '0',
          borderColor: this.themes[`greenFlagColor`],
          fillColor: this.themes[`greenFlagColor`],
          color: this.themes[`greenFlagColor`],
          active: (this.activeButtons & (1 << 2)) > 0,
          label: 'green'
        },
        {
          caption: 'All',
          borderColor: this.themes[`allFlagColor`],
          fillColor: this.themes[`allFlagColor`],
          color: this.themes[`allFlagColor`],
          active: (this.activeButtons & (1 << 3)) > 0,
          label: 'all'
        }
      ]
      return res
    }
  },
  data: () => ({
    buttonCount: 0,
    activeButtons: 0,
    searchedText: '',
    selectedItem: null,
    unsubscribe: null,
    showMore: {},
    showMorePages: {},
    firstReqLength: 0
  }),
  filters: {
    buttonLabel: (array, label) => {
      if (!label || !array) {
        return []
      }
      return array.filter(user => {
        return user.label === label
      })
    }
  },
  created () {
    // calculate active buttons
    this.activeButtons = 31

    if (this.$store.state.account.userUuid !== null && this.$store.state.account.userUuid.length > 0) {
      this.stats(this.$store.state.account.userUuid)
    }

    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'test/testProfileSuccess') {
        document.title = `${config.defaultTitle} - ${this.selectedItem.first_name} ${this.selectedItem.last_name}`
      }
      if (mutation.type === 'test/sharingUsersSuccess') {
        // if we get label more items
        if (mutation.payload.label && mutation.payload.label.length > 0) {
          Vue.set(this.showMore, mutation.payload.label, mutation.payload.sharingUsers.length)
        }

        // on first request that is not search or more req
        if (!mutation.payload.queryName && !mutation.payload.label) {
          // used to show more button on start or not
          this.firstReqLength = mutation.payload.sharingUsers.length
        }
      }
    })

    this.sharingUsers({queryName: undefined, label: undefined})
  },
  destroyed () {
    this.unsubscribe()
  }
}
</script>

<style>
.sidebar-container {
  padding: 0.5rem 0 0.5rem;
  overflow-y: scroll;
  border-left: 3px solid gray;
  margin: 2px 0 2px;
  overflow-x: hidden;
  height: calc(100vh - 8.46154rem);
}
</style>



// WEBPACK FOOTER //
// src/views/Sidebar.vue